/*
 * @Date: 2023-03-01 09:52:51
 * @LastEditTime: 2024-07-17 14:54:49
 * @LastEditors: roccoli
 * @Description: 
 * @FilePath: \pm_md:\workspace\plc_web\src\pc\views\home\pages\index\index.js
 * ©lexin ec-frd
 */
import M_REQUEST from '~request@1.0'
// import M_TOOLKIT from '~toolkit@1.0'
// import Swiper from '@pc/components/libs/swiper/swiper.6.5.0.js'

import topHeader from './components/header/index.vue'
import mainSwiper from './components/mainSwiper/index.vue'
import brand from './components/brand/index.vue'
import products from './components/products/index.vue'
import safe from './components/safe/index.vue'
import service from './components/service/index.vue'
import honor from './components/honor/index.vue'
import bank from './components/bank/index.vue'
import moduleHead from './components/moduleHead/index.vue'
import {dataReport} from '../../../../utils/report'

const G_REQUEST = new M_REQUEST({ gatewayType: 'platform' })
// let G_SWIPER = null
export default {
	components: {
		topHeader,
		mainSwiper,
		brand,
		products,
		safe,
		service,
		honor,
		bank,
		moduleHead
	},

	data() {
		const createDefaultInfo = () => [[{ title: '' }],];
		return {
			isPc: true,
			showScrollTop: false,
			nearBottom: false, // 新增状态变量，用于跟踪是否接近底部
			isScrolling: false, // 添加滚动状态标识
			scrollTimer: null, // 添加滚动定时器
			headInfo: [],
			swiperInfo: [],
			downloadInfo: [],
			brandInfo: createDefaultInfo(),
			productInfo: createDefaultInfo(),
			safetyInfo: createDefaultInfo(),
			serviceInfo: createDefaultInfo(),
			honorInfo: createDefaultInfo(),
			bankInfo: createDefaultInfo(),
			footerInfo: [],
			mobFooterInfo: [],
			backImg:'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251113171421-2fb50714-d1b6-44fb-87f4-c2ed8b849773.png',
			downloadImg:'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251117213615-4f5f2006-6085-4c6b-9aa7-91e24ca28e07.png',
			configData: {
				logoImg: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20251112165620-b0e027a8-97f7-49af-8508-939efc9ffb91.png",
				qrImg: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250911155221-b90bf888-682c-414c-b78e-245fa1f50ce2.png",
				cerImgList: [
					{
						"img": "//cres1.fenqile.cn/home/img/main/brand1--45455a3d74.png",
						"url": "https://szcert.ebs.org.cn/33bf7288-ea21-4106-8a89-c6bf98b9afa8"
					},
					{
						"img": "//cres1.fenqile.cn/home/img/main/brand2--207aff84ba.png",
						"url": "https://ss.knet.cn/verifyseal.dll?sn=e17102344030069228kuou000000&ct=df&a=1&pa=0.8600484942712117"
					}
				]
			},
			linkList: [],
			mobLinkList: [],
			cerImgList: []
		}
	},

	computed: {

	},

	methods: {
		handleClickDownload (){
			dataReport(
                {
                    hottag: `FQL_HOME_MOB_DOWNLOAD_CLICK`,
                    eventPosName: `分期乐mob首页下载点击`,
                    eventType: 2, //点击
                }
            );
			window.open('https://pm.m.fenqile.com/entry/app/download/index.html?scene=platform')
		},
		handleMobScroll() {
			// 设置滚动状态为true
			this.isScrolling = true;
			
			// 清除之前的定时器
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
			
			// 设置定时器，在停止滚动一段时间后将滚动状态设为false
			this.scrollTimer = setTimeout(() => {
				this.isScrolling = false;
			}, 300); // 300ms无滚动则认为停止滚动
		},
		handleInitRes(params) {
			const position_info_list = params.position_info_list || []
			return position_info_list.map(item => {
				return [...item?.material_list || []]
			})

		},
		/**
		 * 查询页面配置{"data":{"useCache":1,"useStore":1,"pageKey":"S_OFFICIAL_BRAND_8","timeStamp":1757473964567,"action":"queryPage"},"system":{"controller":"app/content"},"session":{}}
		 */
		queryPageConfig() {
			G_REQUEST.ajax({
				url: '/route0014/app/content/queryPage.json',
				data: {
					// useCache: 1,
					// useStore: 1,
					pageKey: 'S_FQL_HOME_WEB',
					action: 'queryPage',
				}
			}).then(res => {

				if (+res.retcode === 0) {
					let ret_data = (res && res.result_rows) || {}


					// 是否登录
					let is_login = this.checkLogin(res.system)
					const floorInfoList = ret_data.floor_info_list || []
					// 头部信息
					this.headInfo = floorInfoList[0].position_info_list[0].material_list
					// 轮播图信息
					this.swiperInfo = this.handleInitRes(floorInfoList[1])
					// 分期乐下载信息
					this.downloadInfo = floorInfoList[2].position_info_list[0].material_list[0]
					// 品牌信息
					this.brandInfo = this.handleInitRes(floorInfoList[3])
					// 产品信息
					this.productInfo = this.handleInitRes(floorInfoList[4])
					// 安全信息
					this.safetyInfo = this.handleInitRes(floorInfoList[5])
					// 服务信息
					this.serviceInfo = this.handleInitRes(floorInfoList[6])
					// 荣誉信息
					this.honorInfo = this.handleInitRes(floorInfoList[7])
					// 银行信息
					this.bankInfo = this.handleInitRes(floorInfoList[8])
					// 底部信息
					this.footerInfo = this.handleInitRes(floorInfoList[9])
					// 移动端底部信息
					this.mobFooterInfo = this.handleInitRes(floorInfoList[10])
					for (const item of this.footerInfo) {
						item.forEach(_item => {
							if (_item && _item.img) {
								this.cerImgList.push({
									img: _item.img,
									url: _item.link
								});
							}
						});
					}
					for (const row of this.footerInfo) {
						const rowItem = row[0]; // 获取行内核心数据对象
						if (!rowItem) continue;

						// 提取所有以 text 开头的键（如 text1, text2, text3...）
						const textKeys = Object.keys(rowItem)
							.filter(key => key.startsWith('text'))
							.sort((a, b) => {
								// 按 text 后的数字升序排序，如 text1 < text2
								const numA = parseInt(a.replace('text', ''), 10) || 0;
								const numB = parseInt(b.replace('text', ''), 10) || 0;
								return numA - numB;
							});

						// 当前行的链接数据
						const currentRow = [];

						for (const key of textKeys) {
							const items = rowItem[key] || [];
							for (const item of items) {
								currentRow.push({
									text: item.word || item.text, // 兼容 item.word 或 item.text
									url: item.link,             // 链接地址
									icon: item.img              // 图标（可选）
								});
							}
						}

						// 如果当前行有数据，则添加到 linkList
						if (currentRow.length > 0) {
							this.linkList.push(currentRow);
						}
					}
					for (const row of this.mobFooterInfo) {
						const rowItem = row[0]; // 获取行内核心数据对象
						if (!rowItem) continue;

						// 提取所有以 text 开头的键（如 text1, text2, text3...）
						const textKeys = Object.keys(rowItem)
							.filter(key => key.startsWith('text'))
							.sort((a, b) => {
								// 按 text 后的数字升序排序，如 text1 < text2
								const numA = parseInt(a.replace('text', ''), 10) || 0;
								const numB = parseInt(b.replace('text', ''), 10) || 0;
								return numA - numB;
							});

						// 当前行的链接数据
						const currentRow = [];

						for (const key of textKeys) {
							const items = rowItem[key] || [];
							for (const item of items) {
								currentRow.push({
									text: item.word || item.text, // 兼容 item.word 或 item.text
									url: item.link,             // 链接地址
									icon: item.icon              // 图标（可选）
								});
							}
						}

						// 如果当前行有数据，则添加到 linkList
						if (currentRow.length > 0) {
							this.mobLinkList.push(currentRow);
						}
					}
				}
				dataReport({
					hottag: 'FQL_HOME',
					eventPosName: '分期乐首页曝光',
					eventType: 1,
				})
			})

		},


		/**
		 * 验证是否登录
		 * @param {Object} system_data
		 * @returns {Boolean}
		 */
		checkLogin(system_data) {
			return !!(system_data && system_data.session_id && system_data.token_id && system_data.uid)
		},
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			dataReport({
				hottag: 'FQL_HOME_WEB_TO_TOP',
				eventPosName: '分期乐web首页返回顶部',
				eventType: 2, //点击返回顶部
			})
		},
		// 滚动监听方法
		handleScroll() {
			this.showScrollTop = window.scrollY > 300;
			
			// 计算距离底部的距离
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;
			const distanceToBottom = documentHeight - window.scrollY - windowHeight;
			
			// 当距离底部小于等于480px时，设置nearBottom为true
			this.nearBottom = distanceToBottom <= 480;
		},
		handleBottomExposure() {
			if(this.isPc){
				dataReport({
				hottag: 'FQL_HOME_WEB_BOTTOM_EXPOSURE',
				eventPosName: `分期乐web首页底部曝光`,
				eventType: 1, //曝光
			})
			}
			else{
				dataReport({
				hottag: 'FQL_HOME_MOB_BOTTOM_EXPOSURE',
				eventPosName: `分期乐mob首页底部曝光`,
				eventType: 1, //曝光
			})
			}
		},
		handleClickLink(link) {
			if (link.url) {
				if(this.isPc){
					dataReport({
					hottag: 'FQL_HOME_WEB_BOTTOM_CLICK',
					eventPosName: `分期乐web首页底部点击`,
					eventType: 2, //点击链接
				},{targetLink: link.url})
				}
				else{
					dataReport({
					hottag: 'FQL_HOME_MOB_BOTTOM_CLICK',
					eventPosName: `分期乐mob首页底部点击`,
					eventType: 2, //点击链接
				},{targetLink: link.url})
				}
			}
		},
	},
	watch: {
		linkList: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleBottomExposure();
                }
            },
            deep: true
        }
	},
	mounted() {
		this.queryPageConfig();
		window.addEventListener('scroll', this.handleScroll); // 监听滚动
		window.addEventListener('scroll', this.handleMobScroll);
	},
	beforeDestroy() {
			// 清理事件监听器
			window.removeEventListener('scroll', this.handleMobScroll);
			// 清理定时器
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
		},
	created() {
		let e1 = /\bfenqile_(ios|android)_(\d+\.\d+\.\d+)\b/.test(navigator.userAgent)
		let e2 = /\b(Android|iPhone|iPad|Mobile|Mobi|IEMobile)\b/i.test(navigator.userAgent)
		// if (e1 || e2) {
		// 	location.href = '//m.fenqile.com'
		// }
		this.isPc = e1 || e2 ? false : true
	}
}